import { render, staticRenderFns } from "./ISO15143.vue?vue&type=template&id=c2e1d0d6"
import script from "./ISO15143.vue?vue&type=script&lang=js"
export * from "./ISO15143.vue?vue&type=script&lang=js"
import style0 from "./ISO15143.vue?vue&type=style&index=0&id=c2e1d0d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports